module.exports = __webpack_public_path__ + "assets/img/twokonggou_2.8e2ecb82.jpg";